function Key() {
  return (
    <svg width={40} height={40} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M40 13.828A13.804 13.804 0 0026.172 0C18.594.078 12.5 6.172 12.5 13.75c0 1.563.234 2.969.625 4.375L.547 30.703c-.39.39-.547.86-.547 1.328v6.094C0 39.219.781 40 1.875 40h8.75c1.016 0 1.875-.781 1.875-1.875V35h3.125c1.016 0 1.875-.781 1.875-1.875V30h2.89c.47 0 1.094-.234 1.407-.625l1.875-2.11c.781.157 1.64.235 2.578.235C33.828 27.5 40 21.406 40 13.828zM26.25 10A3.75 3.75 0 0130 6.25c2.031 0 3.75 1.719 3.75 3.75A3.75 3.75 0 0130 13.75c-2.11 0-3.75-1.64-3.75-3.75z"
        fill="#2C2C2C"
      />
    </svg>
  );
}

export default Key;
